import { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Pagination,
  Box,
  CircularProgress,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

export default function UserWorkoutsBlock({ workouts, loading }) {
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (workouts.length === 0) {
    return <Typography>No workouts found.</Typography>;
  }

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const displayedWorkouts = workouts.slice(startIndex, endIndex);

  return (
    <Box>
      {displayedWorkouts.map((workout) => (
        <Card key={workout.id} sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6">{workout.name}</Typography>
            <Typography variant="body2" color="textSecondary">
              {workout.description}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              <FormattedMessage id="userWorkouts.label.equipment" defaultMessage="Equipment Needed" />:{' '}
              {workout.equipmentNeeded ? <CheckIcon color="primary" /> : <CloseIcon color="error" />}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              <FormattedMessage id="userWorkouts.label.category" defaultMessage="Category" />:{' '}
              {workout.categoryName}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              <FormattedMessage id="userWorkouts.label.reviewed" defaultMessage="Reviewed" />:{' '}
              {workout.isReviewed ? <CheckIcon color="primary" /> : <CloseIcon color="error" />}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              <FormattedMessage id="userWorkouts.label.approved" defaultMessage="Approved" />:{' '}
              {workout.isApproved ? <CheckIcon color="primary" /> : <CloseIcon color="error" />}
            </Typography>
          </CardContent>
        </Card>
      ))}
      <Pagination
        count={Math.ceil(workouts.length / ITEMS_PER_PAGE)}
        page={currentPage}
        onChange={handlePageChange}
        sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}
      />
    </Box>
  );
}

UserWorkoutsBlock.propTypes = {
  workouts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      equipmentNeeded: PropTypes.bool.isRequired,
      categoryName: PropTypes.string.isRequired,
      isReviewed: PropTypes.bool.isRequired,
      isApproved: PropTypes.bool.isRequired,
      createdAt: PropTypes.string.isRequired,
    })
  ).isRequired,
  loading: PropTypes.bool.isRequired,
};
